import { AppDispatch } from './store'

type SetLoading = (value: boolean) => (dispatch: AppDispatch) => void

interface State {
  isLoading: boolean,
  isFormLoading: boolean
}

enum EnumActions {
  SET_LOADING = 'SET_LOADING',
  SET_FORM_LOADING = 'SET_FORM_LOADING'
}

type Action =
  | { type: EnumActions.SET_LOADING; payload: boolean }
  | { type: EnumActions.SET_FORM_LOADING; payload: boolean }

export const setLoadingAC = (obj: boolean): Action => ({ type: EnumActions.SET_LOADING, payload: obj })
export const setFormLoadingAC = (obj: boolean): Action => ({ type: EnumActions.SET_FORM_LOADING, payload: obj })

export const setLoading: SetLoading = (value) => (dispatch) => {
  dispatch((setLoadingAC(value)))
}

export const setFormLoading: SetLoading = (value) => (dispatch) => {
  dispatch((setFormLoadingAC(value)))
}
const istate: State = {
  isLoading: false,
  isFormLoading: false
}

const reducer = (state: State = istate, action: Action): State => {
  switch (action.type) {
    case EnumActions.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }

    case EnumActions.SET_FORM_LOADING:
      return {
        ...state,
        isFormLoading: action.payload
      }
    default: return state
  }
}

export default reducer
